(function () {
    'use strict';

    function AdminSettingsCtrl(restangular, toastr, $uibModal) {
        var vm = this;

        restangular
            .one('application')
            .one('secondarycategory')
            .get()
            .then(function (response) {
                vm.secondaryCategories = response;
                vm.aepCategories = _.filter(response, function (o) { return o.primaryCategory == 'AEP' });
                vm.dreCategories = _.filter(response, function (o) { return o.primaryCategory == 'DRE' });
                vm.drePlusCategories = _.filter(response, function (o) { return o.primaryCategory == 'DRE Plus' });
                vm.com2000Categories = _.filter(response, function (o) { return o.primaryCategory == 'COM 2000/3000' });
                vm.miscCategories = _.filter(response, function (o) { return o.primaryCategory == 'Misc' });
            });

        vm.onSecondaryTagAdding = onSecondaryTagAdding;
        vm.onSecondaryTagRemoving = onSecondaryTagRemoving;

        /////////////////////////////////////
        function onSecondaryTagRemoving(tag, primaryCategory) {
            if (vm[primaryCategory].length === 1) {
                toastr.error('At least one secondary category is required.', 'Error');
                return false;
            }
            return $uibModal.open({
                templateUrl: 'scripts/js/admin/settings/confirmdelete.html',
                size: 'md',
                controller: [
                    '$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        $scope.cancel = function () { $uibModalInstance.close(false); }
                        $scope.remove = function () {
                            return vm.secondaryCategories.customDELETE(tag.id).then(function() {
                                    toastr.info('Secondary category removed.', 'Notification');
                                    $uibModalInstance.close(true);
                                },
                                function (err) {
                                    var message = _.get(err, 'data.message') || 'Unable to remove secondary category.';
                                    toastr.error(message, 'Error');
                                    $uibModalInstance.close(false);
                                });
                        };
                    }
                ]
            }).result;
        }

        function capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }

        function onSecondaryTagAdding(tag, primaryCategory) {
            tag.name = capitalize(tag.name);
            return vm.secondaryCategories.customPOST({ secondaryCategory: tag.name, primaryCategory: primaryCategory }).then(function (result) {
                tag.id = result.id;
                toastr.info('Secondary category created.', 'Notification');
                return true;
            }, function () {
                toastr.error('Unable to save secondary category.', 'Error');
                return false;
            });;
        }
    };

    angular
        .module('app')
        .controller('AdminSettingsCtrl', ['Restangular', 'toastr', '$uibModal', AdminSettingsCtrl]);

})();